import React from 'react'
import Divider from '@material-ui/core/Divider'
import { Element, scroller } from 'react-scroll'
import { useUnmount } from 'react-use'
import RouterMetaTags from '../../../components/molecules/RouterMetaTags'
import { Routes } from '../../../consts'
import HeatMap from '../../organisms/HeatMap'
import SearchOptions from '../../organisms/SearchOptions'
import Table from '../../organisms/Table'
import { useCprmSearch } from './hooks'

const Component = () => {
  const { isSearched, handleIsSearched, handleReset } = useCprmSearch()

  React.useEffect(() => {
    if (isSearched) {
      scroller.scrollTo('table', {
        duration: 1000,
        delay: 200,
        smooth: true,
        offset: -60
      })
      handleIsSearched(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearched])

  useUnmount(() => {
    handleReset()
  })

  return (
    <>
      {/* <TmpComponent /> */}
      <RouterMetaTags route={Routes.Search} />
      <HeatMap />
      <Divider style={{ margin: '24px 0' }} />
      <SearchOptions />
      <Element name="table">
        <Divider style={{ margin: '24px 0' }} />
      </Element>
      <Table />
    </>
  )
}

export default Component
